import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Produto from "./pages/Produto";
import EventoPage from "./pages/EventoPage"; 
import VendaPage from "./pages/VendaPage";
import ResumoEventoPage from "./pages/ResumoEventoPage"; // ✅ IMPORTADO
import FiadosPage from "./pages/FiadosPage";
import EquipePage from "./pages/EquipePage";
import EventoVendasPage from "./pages/EventoVendasPage";
import ConfiguracaoImpressora from "./pages/ConfiguracaoImpressora";

import { AuthProvider } from "./context/AuthContext";
import PrivateRoutes from "./routes/PrivateRoutes";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rota pública */}
          <Route path="/" element={<Login />} />

          {/* Rotas privadas */}
          <Route element={<PrivateRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/produto" element={<Produto />} />
            <Route path="/eventos" element={<EventoPage />} />
            <Route path="/vendas" element={<VendaPage />} />

            {/* ✅ NOVA ROTA DO RESUMO */}
            <Route path="/evento/:eventoId/resumo" element={<ResumoEventoPage />} />
            <Route path="/fiados" element={<FiadosPage />} />
            <Route path="/equipes" element={<EquipePage />} />
            <Route path="/evento/:id/vendas" element={<EventoVendasPage />} />
            <Route path="/configuracao-impressora" element={<ConfiguracaoImpressora />} />


          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
